<p-toast></p-toast>
<div class="confirm-dilouge">
  <p-confirmDialog></p-confirmDialog>
</div>

<ngx-ui-loader
  overlayColor="transparent"
  [bgsOpacity]="1"
  fgsType="circle"
  fgsColor="#0141A3"
  pbColor="#0141A3"
  [fgsSize]="50"
  [pbThickness]="1"
/>

<router-outlet />